import Dialog, {
  DialogHeader,
  DialogHeading,
} from '@raydiant/raydial/components/Dialog';
import Modal from '@raydiant/raydial/components/Modal';
import Button from '@raydiant/raydial/components/Button';
import Text from '@raydiant/raydial/components/Text';
import GetYourDeviceImg from './get-your-device.svg';
import CollaborateWithOthersImg from '../LocationOnboardingDialog/collaborate-with-others.svg';
import ManageScreensImg from '../LocationOnboardingDialog/manage-screens.svg';
import OrganizeContentImg from '../LocationOnboardingDialog/organize-content.svg';
import useUpdateOnboardingStatus from '../../../../hooks/useUpdateOnboardingStatus';

export interface ConnectOnboardingDialogProps {
  isOpen: boolean;
}

const ConnectOnboardingDialog = ({ isOpen }: ConnectOnboardingDialogProps) => {
  const updateOnboardingStatus = useUpdateOnboardingStatus();

  const handleUpdateOnboardingStatus = async () => {
    try {
      await updateOnboardingStatus.mutate({ name: 'raydiant_connect' });
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <Modal isOpen={isOpen} className="overflow-auto">
      <Dialog className="grid gap-4 relative">
        <div className="text-black">
          <DialogHeader>
            <DialogHeading>Let's Get Started</DialogHeading>
          </DialogHeader>
          <div className="flex flex-col pt-4 gap-8 md:pl-8 md:pr-[101px]">
            <div className="flex items-center">
              <img src={GetYourDeviceImg} alt="manage access" />
              <div className="flex flex-col flex-1 ml-6">
                <Text variant="smallSubheader" className="mb-1">
                  Get your device
                </Text>
                <Text className="text-gray-600 mb-2" variant="body">
                  Order a ScreenRay and connect it to your display
                </Text>
              </div>
            </div>
            <div className="flex items-center">
              <img src={ManageScreensImg} alt="manage access" />
              <div className="flex flex-col flex-1 ml-6">
                <Text variant="smallSubheader" className="mb-1">
                  Manage Screens
                </Text>
                <Text className="text-gray-600" variant="body">
                  Manage screens for each of your locations
                </Text>
              </div>
            </div>
            <div className="flex items-center">
              <img src={OrganizeContentImg} alt="organize content" />
              <div className="flex flex-col flex-1 ml-6">
                <Text variant="smallSubheader" className="mb-1">
                  Organize Content
                </Text>
                <Text className="text-gray-600" variant="body">
                  Manage content across all of your locations
                </Text>
              </div>
            </div>
            <div className="flex items-center">
              <img
                src={CollaborateWithOthersImg}
                alt="collaborate with others"
              />
              <div className="flex flex-col flex-1 ml-6">
                <Text variant="smallSubheader" className="mb-1">
                  Collaborate with others
                </Text>
                <Text className="text-gray-600" variant="body">
                  Collaborate on screen and content management with your team
                </Text>
              </div>
            </div>
          </div>
          <footer className="flex flex-wrap gap-6 pb-4 px-4 mt-8">
            <Button
              size="large"
              variant="primary"
              className="grow"
              onPress={() => handleUpdateOnboardingStatus()}
            >
              Let's Go!
            </Button>
          </footer>
        </div>
      </Dialog>
    </Modal>
  );
};

export default ConnectOnboardingDialog;
